import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import { trans, doubleNumber } from "../../../helpers/index";
import config from "../../../baseConfig/index";
import ErrorModal from "../../Fragments/ErrorModal";
import ApiManager from "../../../apiManager/index";
import Modal from "../../Fragments/Modal";
const Bonus = (props) => {
  const [bonusData, setBonusData] = useState("");
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmButtonDisabled, setConfirmButtonDisabled] = useState(false);
  const [redeemableItemId, setRedeemableItemId] = useState(null);
  const [bonusBoxLimit, setBonusBoxLimit] = useState(4);
  const [smsSendModal, setSmsSendModal] = useState(false);
  const [dynamicState, setDynamicState] = useState({});

  const mountedRef = useRef(true);
  const resizerTimerRef = useRef(null);
  const heightSetterTimerRef = useRef(null);
  const errorCallBack = useCallback(() => {
    setShowErrorModal(true);
  }, []);

  const getDateFormat = useCallback((dateString, separator = "-") => {
    const dt = new Date(dateString);
    return (
      doubleNumber(dt.getDate()) +
      separator +
      doubleNumber(dt.getMonth() + 1) +
      separator +
      dt.getFullYear()
    );
  }, []);

  const setOptionsFromData = useCallback((dataObj) => {
    if (!dataObj || dataObj.status !== "OK") return;
    const data = dataObj.data && dataObj.data.QueryAvailableCategory;
    if (!data) return;

    const newState = {};
    for (const id in data) {
      const optionsKey = "options-" + data[id]["Id"];
      const selectedKey = "selected-option-" + data[id]["Id"];
      newState[optionsKey] = [];
      if (data[id]["Category"]) {
        for (let category in data[id]["Category"]) {
          newState[optionsKey].push({
            label: data[id]["Category"][category]["Description"],
            value: data[id]["Category"][category]["Id"],
          });
        }
      }
      if (newState[optionsKey].length) {
        newState[selectedKey] = newState[optionsKey][0];
      }
    }
    if (Object.keys(newState).length) {
      setDynamicState((prev) => ({ ...prev, ...newState }));
    }
  }, []);

  const bonusSuccess = useCallback((resolve) => {
    if (!mountedRef.current) return;
    
    console.log("Bonus request success:", resolve.data);
    
    setBonusData(resolve.data);
    setShowErrorModal(resolve.data.status !== "OK");
    setOptionsFromData(resolve.data);
  }, [setOptionsFromData]);

  const initAsyncCalls = useCallback(() => {
    if (!props.parentState || props.parentState.accountData.status !== "OK") {
      return;
    }
    ApiManager.getRequest(
      {
        _token: props.csrf_token.data,
        jwt: props.getDecryptedToken(),
        subscriberId: props.parentState.accountData.data.number.replace(/\s|^\+3/g, ""),
      },
      "/bonus"
    ).then(bonusSuccess, errorCallBack);
  }, [props, bonusSuccess, errorCallBack]);

  const scheduleHeightSetter = useCallback(() => {
    if (!mountedRef.current) return;
    if (heightSetterTimerRef.current) {
      clearTimeout(heightSetterTimerRef.current);
    }
    const run = () => {
      const lists = document.getElementsByClassName("bonus__section-middle-list");
      if (lists.length) {
        const itemNames = [
          "bonus__section-middle-gray-box-top--1",
          "bonus__section-middle-gray-box-top--2",
          "bonus__section-middle-gray-box-point",
        ];
        for (let itemNames_i = 0, itemNames_l = itemNames.length; itemNames_i < itemNames_l; itemNames_i++) {
          for (let list_i = 0, list_l = lists.length; list_i < list_l; list_i++) {
            let height = 0;
            const item = lists[list_i].getElementsByClassName(itemNames[itemNames_i]);
            for (let item_i = 0, item_l = item.length; item_i < item_l; item_i++) {
              item[item_i].style.height = "auto";
              const style = window.getComputedStyle ? getComputedStyle(item[item_i], null) : item[item_i].currentStyle;
              const heightWidthoutPaddings = item[item_i].clientHeight - (parseInt(style.paddingTop) || 0) - (parseInt(style.paddingBottom) || 0);
              if (heightWidthoutPaddings > height) {
                height = heightWidthoutPaddings;
              }
            }
            for (let item_i = 0, item_l = item.length; item_i < item_l; item_i++) {
              item[item_i].style.height = height + "px";
            }
          }
        }
      }
      if (mountedRef.current) {
        heightSetterTimerRef.current = setTimeout(run, 100);
      }
    };
    run();
  }, []);

  const resizer = useCallback(() => {
    const winWidth = window.innerWidth || window.screen.availWidth;
    if (winWidth < 1451 && winWidth > 1300) {
      setBonusBoxLimit(3);
    } else if (winWidth < 1301 && winWidth > 1100) {
      setBonusBoxLimit(2);
    } else {
      setBonusBoxLimit(4);
    }
    scheduleHeightSetter();
  }, [scheduleHeightSetter]);

  const errorModal = useCallback(() => {
    if (!showErrorModal) {
      return "";
    }
    let message = trans(props.trans, "error.modal.description");
    if (bonusData !== "" && bonusData.status !== "OK") {
      if (typeof bonusData.message === "string") {
        message = bonusData.message;
      } else if (typeof bonusData.message === "object" && bonusData.message.length) {
        message = bonusData.message.join(" ");
      }
    }
    return (
      <ErrorModal
        title={trans(props.trans, "error.modal.title")}
        description={message}
        action_text={trans(props.trans, "error.modal.action_text")}
      />
    );
  }, [showErrorModal, bonusData, props.trans]);

  const activateBonus = useCallback((id) => {
    setRedeemableItemId(id);
    setConfirmModal(true);
  }, []);

  const parseJwt = useCallback((token) => {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map(function (c) {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );
    return JSON.parse(jsonPayload);
  }, []);

  const bonusActivateSuccess = useCallback((resolve) => {
    if (!mountedRef.current) return;
    setConfirmButtonDisabled(false);
    if (resolve.data.status === "OK") {
      setRedeemableItemId(null);
      setConfirmModal(false);
      setSmsSendModal(true);
      setBonusData("");
      initAsyncCalls();
    } else {
      errorCallBack();
    }
  }, [initAsyncCalls, errorCallBack]);

  const activateCurrentBonus = useCallback(() => {
    setConfirmButtonDisabled(true);
    ApiManager.postRequest(
      {
        _token: props.csrf_token.data,
        jwt: props.getDecryptedToken(),
        subscriberId: props.parentState.accountData.data.number.replace(/\s|^\+3/g, ""),
      },
      `/bonus/purchase/${redeemableItemId}`
    ).then(bonusActivateSuccess, errorCallBack);
  }, [props, redeemableItemId, bonusActivateSuccess, errorCallBack]);

  const userBonusState = useCallback(() => {
    let bonusSum = 0,
      balanceLog = "",
      showSingle = false,
      registeredDate = "...";

    if (
      bonusData !== "" &&
      bonusData.status === "OK" &&
      bonusData.data &&
      bonusData.data.info &&
      bonusData.data.info.hasOwnProperty("rewardsPointsBalance")
    ) {
      bonusSum = bonusData.data.info.rewardsPointsBalance;
    } else if (
      bonusData !== "" &&
      bonusData.status === "OK" &&
      bonusData.data &&
      bonusData.data.QueryPoints &&
      bonusData.data.QueryPoints.hasOwnProperty("Wallet") &&
      bonusData.data.QueryPoints.Wallet.hasOwnProperty("Points")
    ) {
      bonusSum = bonusData.data.QueryPoints.Wallet.Points;
    }

    if (bonusData !== "" && bonusData.status === "OK") {
      const pointsReward =
        bonusData.data &&
        bonusData.data.points &&
        Array.isArray(bonusData.data.points.reward)
          ? bonusData.data.points.reward
          : null;
      const pointsStatus =
        bonusData.data &&
        bonusData.data.points &&
        Array.isArray(bonusData.data.points.status)
          ? bonusData.data.points.status
          : null;

      let logItems = [];

      if (pointsReward && pointsReward.length) {
        const rewardLogItems = [
          <p className="bonus__point-amount fs14 fb" key={`reward-title`}>
            {trans(props.trans, "bonus.balance.reward_points_title")}
          </p>,
          ...pointsReward.map((item, index) => {
            return (
              <p className="bonus__point-amount fs14" key={`reward-${index}`}>
                <b>
                  {item.balance} {trans(props.trans, "bonus.balance.reward_points_title")}
                </b>{" "}
                {trans(props.trans, "bonus.balance.valid_to_title")} {" "}
                <b>{item.expirationDate}</b>
              </p>
            );
          })
        ];
        logItems = logItems.concat(rewardLogItems);
      }

      if (pointsStatus && pointsStatus.length) {
        const statusLogItems = [
          ...pointsStatus.map((item, index) => {
            return (
              <p className="bonus__point-amount fs14" key={`status-${index}`}>
                <b>
                  {item.balance} {trans(props.trans, "bonus.balance.status_points_title")}
                </b>{" "}
                {trans(props.trans, "bonus.balance.valid_to_title")} {" "}
                <b>{item.expirationDate}</b>
              </p>
            );
          })
        ];
        logItems = logItems.concat(statusLogItems);
      }

      if (logItems.length) {
        balanceLog = (
          <>
            <div className="bonus__period-box">{logItems}</div>
          </>
        );
        showSingle = true;
      }
    }

    if (
      bonusData !== "" &&
      bonusData.status === "OK" &&
      bonusData.data &&
      bonusData.data.hasOwnProperty("IsCustomerRegistered") &&
      bonusData.data.IsCustomerRegistered &&
      bonusData.data.IsCustomerRegistered.hasOwnProperty("RegistrationDate")
    ) {
      registeredDate =
        getDateFormat(bonusData.data.IsCustomerRegistered.RegistrationDate, ".") +
        trans(props.trans, "bonus.wallet.year_prefix");
    }
    const tierName = bonusData?.data?.info?.tierName;
    return (
      <div className="bonus__amount-box tc fl">
        <h2 className="bonus__amount-title fs24 monserrat-medium tu">
          {trans(props.trans, "bonus.wallet.title")}
        </h2>
        <p className="bonus__amount-description fs12">
          {trans(props.trans, "bonus.wallet.join_to_bonus_title")}
          <span className="bonus__amount-date monserrat-medium" style={{ marginLeft: "5px" }}>
            {tierName}
          </span>
        </p>
        <div
          className={`bonus__number-box${
            showSingle ? "" : " bonus__number-box--single"
          }`}
        >
          <b className="bonus__amount fs30">{bonusSum}</b>{" "}
          <span className="bonus__prefix fs30">
            {trans(props.trans, "bonus.wallet.sum_title")}
          </span>
        </div>
        {balanceLog}
      </div>
    );
  }, [bonusData, getDateFormat, props.trans]);

  const userBonusTariffs = useCallback(() => {
    let bonusPackages = ["standard", "silver", "gold", "platinum"],
      activeItem = "";

    const tierMetaMap = {};
    if (bonusData !== "" && bonusData.status === "OK") {
      const data = bonusData.data || {};
      const tiers = data.tiers || null;

      if (tiers && tiers.current && tiers.current.tierTitle) {
        activeItem = String(tiers.current.tierTitle).toLocaleLowerCase();
      } else {
        const tierName = data && data.info && data.info.tierName ? data.info.tierName : null;
        if (tierName) {
          activeItem = tierName.toLocaleLowerCase();
        } else if (data.GetCustomerDetails && data.GetCustomerDetails.Fidelity) {
          activeItem = data.GetCustomerDetails.Fidelity.Code.toLocaleLowerCase();
        }
      }

      if (tiers) {
        const packages = [];
        if (tiers.current && tiers.current.tierTitle) {
          const key = String(tiers.current.tierTitle).toLocaleLowerCase();
          packages.push(key);
          tierMetaMap[key] = tiers.current;
        }
        if (Array.isArray(tiers.other)) {
          tiers.other.forEach(function (t) {
            if (t && t.tierTitle) {
              const key = String(t.tierTitle).toLocaleLowerCase();
              packages.push(key);
              tierMetaMap[key] = t;
            }
          });
        }
        if (packages.length) {
          bonusPackages = packages;
        }
      }
    }

    const bonusPackagesItems = bonusPackages.map((item, index) => {
      let imgPath = `${config.imgURLPrefix}img/bonus/${item}.png`;
      if (item === "platinum" && activeItem === "platinum") {
        imgPath = `${config.imgURLPrefix}img/bonus/${item}-white.png`;
      }
      return (
        <div className="bonus__packages-item" key={index}>
          <div
            className={`bonus__packages-inner bonus__packages-inner--${item} pr tc${
              activeItem === item ? ` bonus__packages-inner--${item}-bg bonus__packages-inner--active` : ``
            }`}
          >
            <div className="bonus__packages-box tc">
              <div className="bonus__packages-title-out">
                <h3 className="bonus__packages-title monserrat-medium fs24 tu">
                  {tierMetaMap[item] && tierMetaMap[item].tierTitle
                    ? trans(props.trans, tierMetaMap[item].tierTitle)
                    : tierMetaMap[item] && tierMetaMap[item].tierTitle
                      ? tierMetaMap[item].tierTitle
                      : trans(props.trans, `bonus.wallet.package_${item}_title`)}
                </h3>
              </div>
              <div className="bonus__icon-circle pr ver-top-box">
                <img
                  className="bonus__packages-img center-center"
                  src={imgPath}
                  alt={trans(props.trans, `bonus.wallet.package_${item}_title`)}
                />
              </div>
            </div>
            <div className="bonus__number-box bonus__number-box--inner">
              <span className="bonus__amount fb fs22">
                {tierMetaMap[item] && tierMetaMap[item].tierSubTitle
                  ? trans(props.trans, tierMetaMap[item].tierSubTitle)
                  : trans(props.trans, `bonus.wallet.package_${item}_bonus_title`)}
              </span>
            </div>
            <div className="bonus__packages-desc">
              <div className="table">
                <div className="table-cell">
                  {tierMetaMap[item] && Array.isArray(tierMetaMap[item].tierDescription) && tierMetaMap[item].tierDescription.length ? (
                    tierMetaMap[item].tierDescription.map((descText, idx) => (
                      <p className="bonus__packages-txt fs13" key={idx}>{descText}</p>
                    ))
                  ) : (
                    <>
                      <p className="bonus__packages-txt fs13">
                        {trans(props.trans, `bonus.wallet.package_${item}_bonus_description_1`)}
                      </p>
                      <p className="bonus__packages-txt fs13">
                        {trans(props.trans, `bonus.wallet.package_${item}_bonus_description_2`)}
                      </p>
                      <p className="bonus__packages-txt fs13">
                        {trans(props.trans, `bonus.wallet.package_${item}_bonus_description_3`)}
                      </p>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });

    let currentStatus = "";
    if (activeItem !== "") {
      currentStatus = (
        <div className="bonus__packages">
          <div
            className={`bonus__packages-item bonus__packages-item--${activeItem}`}
            style={{
              marginLeft: bonusPackages.indexOf(activeItem) * (100 / bonusPackages.length) + "%",
            }}
          >
            <div className="bonus__packages-current-header fs15 monserrat-medium tc pr">
              {trans(props.trans, "bonus.wallet.current_status_title")}
            </div>
          </div>
        </div>
      );
    }

    let customerAccumulatedPoints = 0,
      customerTierEndDate = "...";
    if (bonusData !== "" && bonusData.status === "OK") {
      const data = bonusData.data || {};
      if (data.hasOwnProperty("PointsLastPeriodInfo") && data.PointsLastPeriodInfo) {
        if (data.PointsLastPeriodInfo.hasOwnProperty("TotalPointsAccumulated")) {
          customerAccumulatedPoints = data.PointsLastPeriodInfo.TotalPointsAccumulated;
        }
        if (data.PointsLastPeriodInfo.hasOwnProperty("TierEndDate")) {
          customerTierEndDate = getDateFormat(data.PointsLastPeriodInfo.TierEndDate, ".") +
            trans(props.trans, "bonus.wallet.year_prefix");
        }
      } else if (data.points && Array.isArray(data.points.status) && data.points.status.length) {
        const pointsStatus = data.points.status;
        customerAccumulatedPoints = pointsStatus.reduce((sum, it) => sum + (parseInt(it.balance, 10) || 0), 0);
        const parseDDMMYYYY = (s) => {
          const parts = String(s).split(".");
          if (parts.length !== 3) return null;
          const d = parseInt(parts[0], 10);
          const m = parseInt(parts[1], 10);
          const y = parseInt(parts[2], 10);
          if (isNaN(d) || isNaN(m) || isNaN(y)) return null;
          return new Date(y, m - 1, d);
        };
        let earliestStr = null;
        let earliestDate = null;
        pointsStatus.forEach((it) => {
          if (!it || !it.expirationDate) return;
          const dt = parseDDMMYYYY(it.expirationDate);
          if (!dt) return;
          if (!earliestDate || dt < earliestDate) {
            earliestDate = dt;
            earliestStr = it.expirationDate;
          }
        });
        if (earliestStr) {
          customerTierEndDate = earliestStr + trans(props.trans, "bonus.wallet.year_prefix");
        }
      }
    }

    return (
      <div className="bonus__packages-outer">
        <div className="bonus__packages-group">
          <div className="bonus__packages-group-top pr sprite-a tc">
            <p className="bonus__packages-group-top-desc fs26">
              {trans(props.trans, "bonus.wallet.count_points_title")} <b>{customerAccumulatedPoints}</b>
            </p>
            <p className="bonus__packages-group-top-desc">
              {trans(props.trans, "bonus.wallet.status_review_title")} {customerTierEndDate}
            </p>
            <div className="form__info-box pa tr">
              <span className="form__info sprite db"> </span>
              <div className="form__info-txt fs11 pa">{trans(props.trans, "bonus.wallet.info")}</div>
            </div>
          </div>
          <div className="bonus__packages-group-bottom scroller-block">
            {currentStatus}
            <div className="bonus__packages">{bonusPackagesItems}</div>
          </div>
        </div>
      </div>
    );
  }, [bonusData, getDateFormat, props.trans]);

  const drawCategoryItems = useCallback((group, groupKey) => {
    let items = [],
      boxIndex = 1,
      boxCount = 0,
      toggleButton = "";

    if (bonusData !== "" && bonusData.status === "OK") {
      let bonusSum = "close";
      if (
        bonusData !== "" &&
        bonusData.status === "OK" &&
        bonusData.data &&
        bonusData.data.info &&
        bonusData.data.info.hasOwnProperty("rewardsPointsBalance")
      ) {
        bonusSum = bonusData.data.info.rewardsPointsBalance;
      } else if (
        bonusData !== "" &&
        bonusData.status === "OK" &&
        bonusData.data &&
        bonusData.data.QueryPoints &&
        bonusData.data.QueryPoints.hasOwnProperty("Wallet") &&
        bonusData.data.QueryPoints.Wallet.hasOwnProperty("Points")
      ) {
        bonusSum = bonusData.data.QueryPoints.Wallet.Points;
      }

      const groupItems = group && Array.isArray(group.offers) ? group.offers : [];
      if (groupItems && groupItems.length) {
        boxCount = groupItems.length;
        for (let i = 0; i < groupItems.length; i++) {
          const it = groupItems[i];
          if (!dynamicState["toggle-group-" + groupKey] && boxIndex > bonusBoxLimit) {
            break;
          }
          items.push(
            <li className="bonus__section-middle-list-item tc" key={boxIndex}>
              <div className="bonus__section-middle-gray-box">
                <div className="bonus__section-middle-gray-box-top bonus__section-middle-gray-box-top--1 bonus__section-middle-gray-box-top--normal-line fb fs32">
                  {it.name}
                </div>
                <div className="bonus__section-middle-gray-box-top bonus__section-middle-gray-box-top--2">
                  {it.description}
                </div>
                <div className="bonus__section-middle-gray-box-bottom">
                  <p className="fs14 bonus__section-middle-gray-box-activate-payment">
                    {trans(props.trans, "bonus.wallet.package_item_activate_payment")}
                  </p>
                  <p className="bonus__section-middle-gray-box-point fs20">
                    <b className="fs24">{it.salesChannelAmount}</b> {trans(props.trans, "bonus.wallet.package_item_point")}
                  </p>
                  <p className="bonus__section-middle-gray-box-payment fs20">
                    <b className="fs24"> + {it.amount}</b> {trans(props.trans, "bonus.wallet.package_item_amount")}
                  </p>
                  <button
                    className="btn btn--white fs17"
                    type="button"
                    disabled={it.salesChannelAmount > bonusSum || bonusSum === "close" || it.canPurchase === false}
                    onClick={() => activateBonus(it.id)}
                  >
                    {trans(props.trans, "bonus.wallet.package_button_title")}
                  </button>
                </div>
              </div>
            </li>
          );
          boxIndex++;
        }
      }
    }

    if (boxCount > bonusBoxLimit) {
      toggleButton = (
        <div className="bonus__section-bottom-box tr">
          <button
            className={`bonus__section-bottom-btn pr sprite-a${
              dynamicState["toggle-group-" + groupKey] ? " bonus__section-bottom-btn--active" : ""
            }`}
            type="button"
            onClick={() => {
              setDynamicState((prev) => {
                const nextVal = !prev["toggle-group-" + groupKey];
                return { ...prev, ["toggle-group-" + groupKey]: nextVal };
              });
            }}
          >
            {trans(
              props.trans,
              "bonus.wallet.package.show_" + (dynamicState["toggle-group-" + groupKey] ? "less" : "more") + "_title"
            )}
          </button>
        </div>
      );
    }

    return (
      <>
        <div className={`bonus__section-middle-box${toggleButton === "" ? " bonus__section-middle-box--bottom-radius" : ""}`}>
          <ul className="bonus__section-middle-list">{items}</ul>
        </div>
        {toggleButton}
      </>
    );
  }, [bonusData, bonusBoxLimit, dynamicState, props.trans, activateBonus]);

  const drawCategories = useCallback(() => {
    // At this point, we know bonusData is successful (status === "OK")
    const data = bonusData.data && bonusData.data.offers;
    
    if (!Array.isArray(data) || data.length === 0) {
      return (
        <section className="main-wrapper__services main-wrapper__services--with-space">
          <div style={{ padding: "40px", textAlign: "center" }}>
            <p className="fs16">{trans(props.trans, "bonus.no.offers.available")}</p>
          </div>
        </section>
      );
    }

    const categoryList = data.map((item, index) => {
      return (
        <div className="bonus__section-box" key={index}>
          <div className="bonus__section-top-box clear-fix">
            <div className="bonus__section-top-box-left fl">
              <h3 className="bonus__section-top-box-title fs24 pr">
                <img
                  className="bonus__section-top-box-icon pa"
                  src={`${config.imgURLPrefix}img/bonus/14.png`}
                  alt={item["categoryName"]}
                />
                {item["categoryName"]}
              </h3>
            </div>
          </div>
          {drawCategoryItems(item, index)}
        </div>
      );
    });

    return <>{categoryList}</>;
  }, [bonusData, drawCategoryItems, props.trans]);

  const confirmModalNode = useCallback(() => {
    if (!confirmModal) {
      return "";
    }
    return (
      <Modal
        title={trans(props.trans, "bonus.confirm.title")}
        description={trans(props.trans, "bonus.confirm.description")}
        agreeText={trans(props.trans, "bonus.confirm.agree")}
        cancelText={trans(props.trans, "bonus.confirm.cancel")}
        showCancelButton={true}
        confirmButtonDisabled={confirmButtonDisabled}
        agreeAction={activateCurrentBonus}
        cancelAction={() => setConfirmModal(false)}
        className="modal--full"
      />
    );
  }, [confirmModal, confirmButtonDisabled, props.trans, activateCurrentBonus]);

  const smsSendModalNode = useCallback(() => {
    if (!smsSendModal) {
      return "";
    }
    return (
      <Modal
        title={trans(props.trans, "bonus.sms.send.title")}
        description={trans(props.trans, "bonus.sms.send.description")}
        agreeText={trans(props.trans, "bonus.sms.send.agree")}
        agreeAction={() => setSmsSendModal(false)}
        className="modal--full"
      />
    );
  }, [smsSendModal, props.trans]);

  useEffect(() => {
    mountedRef.current = true;
    initAsyncCalls();
    window.onresize = () => {
      if (resizerTimerRef.current) {
        clearTimeout(resizerTimerRef.current);
      }
      resizerTimerRef.current = setTimeout(resizer, 20);
    };
    resizer();
    scheduleHeightSetter();
    return () => {
      mountedRef.current = false;
      if (resizerTimerRef.current) clearTimeout(resizerTimerRef.current);
      if (heightSetterTimerRef.current) clearTimeout(heightSetterTimerRef.current);
      window.onresize = null;
    };
  }, [initAsyncCalls, resizer, scheduleHeightSetter]);

  useEffect(() => {
    if (props.parentState && props.parentState.switchAccount) {
      setBonusData("");
    }
  }, [props.parentState && props.parentState.switchAccount]);

  useEffect(() => {
    if (props.parentState && props.parentState.switchAccount && props.parentState.accountData !== "") {
      initAsyncCalls();
    }
  }, [props.parentState && props.parentState.switchAccount, props.parentState && props.parentState.accountData, initAsyncCalls]);

  // Show loading state while data is being fetched
  if (bonusData === "") {
    return (
      <div className="bonus">
        <div className="loading-box pr" style={{ minHeight: "400px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <div className="loading"></div>
        </div>
      </div>
    );
  }

  // Show clean screen if request failed
  if (bonusData !== "" && bonusData.status !== "OK") {
    return (
      <div className="bonus">
        {errorModal()}
      </div>
    );
  }

  // Show success state - bonus page content
  return (
    <div className="bonus">
      <div className="bonus__top-box clear-fix">
        {userBonusState()}
        {userBonusTariffs()}
      </div>

      {drawCategories()}

      <div className="bonus__btn-group">
        <a
          className="btn btn--white fs17 ver-top-box"
          href={trans(props.trans, "bonus.bottom.button_anchor_1")}
          target="_blank"
          rel="noopener noreferrer"
        >
          {trans(props.trans, "bonus.bottom.button_title_1")}
        </a>
        {/* <Link className="btn btn--white fs17 ver-top-box" to={config.urlPrefix + "profile/history"}>
          {trans(props.trans, "bonus.bottom.button_title_2")}
        </Link> */}
        <a
          className="btn btn--white fs17 ver-top-box"
          href={trans(props.trans, "bonus.bottom.button_anchor_3")}
          target="_blank"
          rel="noopener noreferrer"
        >
          {trans(props.trans, "bonus.bottom.button_title_3")}
        </a>
      </div>

      {confirmModalNode()}
      {errorModal()}
      {smsSendModalNode()}
    </div>
  );
};

export default Bonus;